import WbLogo from "url:../static/img/logos/WBG-Logo.png";
import WBGLogoWhite from "url:../static/img/logos/WBG-Logo-White.png";
import ESMAPLogo from "url:../static/img/logos/ESMAP-logo.svg";
import ESMAPLogoWhite from "url:../static/img/logos/ESMAP-Logo-White.png";
import LandingPage from "url:../static/img/Landing-Page.png";
import AboutImg from "url:../static/img/About.png";
import VidaLogo from "url:../static/img/logos/VIDA-Logo.png";
import VidaLogoWhite from "url:../static/img/logos/VIDA-Logo-White.png";
import M300Logo from "url:../static/img/logos/M300-Icon.png";

export {WbLogo, WBGLogoWhite, ESMAPLogo, ESMAPLogoWhite, LandingPage, AboutImg, VidaLogo, VidaLogoWhite, M300Logo};
